import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Reducers } from '../Interfaces/Interfaces';
import { getAggregatorDetails } from '../redux/actions/userActions';
import Placeholder from './Skeleton';

export default function SalesRep() {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const sales = useSelector((state: Reducers) => state.sales);

  const [page] = React.useState(0);
  const [pageSize] = React.useState(10);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();


  let filter: any = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter)
  }

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  }

  // const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
  //   setPage(value);
  // };

  // const handlePageSizeChange = (event: React.MouseEvent<HTMLButtonElement> | null, value: any) => {
  //   setPageSize(value.props.value);
  //   dispatch({ type: "LOADING", payload: true });
  //   paginationConfig.pageSize = value.props.value;
  //   // dispatch(getTransactions(paginationConfig));
  // };

  React.useEffect(() => {
    dispatch(getAggregatorDetails(user.id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);


  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        // enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <div className="col-md-12 modal-container">

      <DialogContent>
        {sales ? (
          <React.Fragment>
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="thead-primary">
                  <tr className="text-center">
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Phone</th>
                    <th scope="col">Email</th>
                    <th scope="col">Role</th>
                  </tr>
                </thead>

                <tbody>
                  {sales.length !== 0 && sales?.map((item: any, index: number) => (
                    <tr key={index} className="text-center">
                      <th scope="row">{getIndexSeed(index)}</th>
                      <td>{item.name}</td>
                      <td>{item.phoneNumber}</td>
                      <td>{item.emailAddress}</td>
                      <td>{item.role}</td>
                    </tr>
                  ))}

                </tbody>
              </table>
            </div>

            {sales.length === 0 &&
              <React.Fragment>
                <p className='text-center mt-3 text-dark w-100'>No result</p>
              </React.Fragment>
            }
          </React.Fragment>
        ) : (

            <React.Fragment>
              <div className="col-md-12 text-center">
                <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
              </div>
              <div className="col-md-12 text-center">
                <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
              </div>
              <div className="col-md-12 text-center">
                <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
              </div>

            </React.Fragment>
          )}
      </DialogContent>

    </div>

  )
}
